import React from 'react'
import '../sass/main.css'
import topLogo  from '../imgs/logowhite.PNG';
import c12 from '../imgs/c121.png';
import c13 from '../imgs/c131.png';
// import {Link as Link2} from 'react-router-dom';

const Header = () => {
    return (
        <div className='header'>

           
<div className='tours-container'>
</div>

        <div className='header__logo-box'>
         <img src={topLogo} alt='logo' className='header__logo'/>
         </div>
         <img src={c12} className='pie1'/>
           <img src={c13} className='pie2'/>
        <div className='text-box'>
            <p className='header-1'>
                Explore  The
            </p>
            <p className='header-2'>Wonders</p>

            <p className='header-3'>of Nature</p>

        </div>
    
         </div>
        
    )
}



export default Header;
